import { type CollegamentoRichiestaDTO } from '@framework/api-client/api/inquiries-compile/schemas/collegamentoRichiestaDTO.ts';
import { t } from '@framework/i18n/intl/i18next.ts';
import { useHistory } from '@framework/ui/core/router/TypedRoute.tsx';
import { message } from 'antd';
import { useCallback, useState } from 'react';
import { redirectToSubmissionPage } from '../../../routes/submission/components/principal-module-redirector/redirectToSubmissionPage.tsx';
import { useCreateSubmission } from '../../submissions/hooks/useCreateSubmission.ts';

/**
 * Hook che permette di creare una nuova richiesta con eventuali links.
 */
export function useCreateSubmissionAndLinks(
  inquiryId?: string | null,
  links?: CollegamentoRichiestaDTO[],
) {
  const { createSubmission } = useCreateSubmission({
    inquiryId,
    links,
  });

  const [loading, setLoading] = useState(false);

  const history = useHistory();

  const handleClick = useCallback(async () => {
    try {
      setLoading(true);
      const request = await createSubmission();

      if (!request?.id) {
        message.error(
          t(
            'create-request-button.error',
            'Errore durante la creazione della richiesta',
          ),
        );
        return;
      }

      // Se richiesto, faccio il redirect al primo modulo
      await redirectToSubmissionPage(request.id, history);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  }, [createSubmission, history]);

  return { handleClick, loading };
}
